import React, { useState } from "react";
import { Modal, Button, Table } from "antd";
import type { ColumnsType } from "antd/es/table";

interface DataType {
  dob: string;
  name: string;
  relation: string;
}

type RegistrationSlipModalProps = {
    isModalOpen: boolean;
    handleSave: any;
    handleCancel: () => void;
    registrationSlipPatients: DataType[];
}

const RegistrationSlipModal: React.FC<RegistrationSlipModalProps> = ({
    isModalOpen,
    handleSave,
    handleCancel,
    registrationSlipPatients
}) => {
  const [selectedId, setSelectedId] = useState<any>(null);

  const columns: ColumnsType<DataType> = [
    {
      title: "Select",
      dataIndex: "select",
      render: (_: any, record: DataType) => (
        <input
          type="checkbox"
          checked={selectedId === (record.name + "~" + record.dob)}
          onChange={() => handleCheckboxChange(record.name + "~" + record.dob)}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "DOB",
      dataIndex: "dob",
    },
    {
      title: "Relation",
      dataIndex: "relation",
    },
  ];

  const handleCheckboxChange = (id: any) => {
    setSelectedId((prev: any) => (prev === id ? null : id));
  };

  return (
    <>
      <Modal
        title="Select Patient"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={() => {
            handleSave(selectedId);
            setSelectedId(null); // Reset selection after saving
          }} disabled={selectedId === null}>
            Save
          </Button>,
        ]}
      >
        <Table
          dataSource={registrationSlipPatients}
          columns={columns}                      
          rowKey="name"
          pagination={false}
        />
      </Modal>
    </>
  );
};

export default RegistrationSlipModal;
